module.exports = __webpack_public_path__ + "img/case-safe-cooperation.a0a23fd3.png";